import type { FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Button } from '@mint-lib/tw-components';
import { Alert } from '@mint-lib/tw-components/patterns';

type Props = {
  onRetry: () => void;
};

const RecipientsCommentsTabError: FC<Props> = ({ onRetry }) => {
  const { t } = useTranslation('@mint-lib/approval-flow-circuit_v2');

  return (
    <Alert
      severity="error"
      title={t('Failed to retrieve the list of emails.')}
      variant="inline"
      removable={false}
    >
      <Button
        data-dd-action-name="Retry action"
        size="small"
        variant="outlined"
        type="button"
        onClick={onRetry}
      >
        {t('Try again')}
      </Button>
    </Alert>
  );
};

export default RecipientsCommentsTabError;
